// extracted by mini-css-extract-plugin
module.exports = {"cookieConsentBar-link":"CookieConsentBar-module--cookieConsentBar-link--3oDMM"};